import { TokenSymbol } from "../../../../types/mod";
import { SEARCH_TOKENS_PRO } from "../../../../config/bizConfig";

export const tokenOrder = SEARCH_TOKENS_PRO;